import { useEffect, useState } from "react";
import { m, AnimatePresence } from "framer-motion";

/** Soft "please reopen" banner when the API reports a newer required app version
 *  (frontend.md / Phase 2 gate). The event is dispatched from lib/api.ts. */
export function StaleVersionBanner() {
  const [required, setRequired] = useState<string | null>(null);

  useEffect(() => {
    const onStale = (e: Event) => setRequired((e as CustomEvent<{ required: string }>).detail.required);
    window.addEventListener("app:stale-version", onStale);
    return () => window.removeEventListener("app:stale-version", onStale);
  }, []);

  return (
    <AnimatePresence>
      {required && (
        <m.div
          key="stale"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.18 }}
          className="bg-tg-button px-4 py-2 text-center text-sm text-tg-button-text"
        >
          A new version is available — close and reopen the app.
        </m.div>
      )}
    </AnimatePresence>
  );
}
